/* sections/cart-notification.js */
setTimeout(function(){
  class CartNotification extends HTMLElement {
    constructor() {
      super();
      this.notification = document.getElementById('cart-notification');
      this.renderContentsOnLoad();
      this.closeTimeoutID = null;
    }

    renderContentsOnLoad() {
      var _this = this;
      fetch(`${window.Shopify.routes.root}?sections=cart-notification-content,cart-notification-crosssell-products`)
        .then((response) => response.json())
        .then((parsedState) => {
          const parsedStateSections = parsedState;
          _this.updateContent(parsedStateSections);
          fetch(window.Shopify.routes.root + 'cart.js')
            .then((response) => response.json())
            .then((parsedState) => {
              window.cartCount && window.cartCount(parsedState);
            })
            .catch((e) => console.error(e));
        })
        .catch((e) => console.error(e));
    }

    open(autoClose) {
      this.notification.classList.add('active');
      document.body.classList.add('minicart-active');
      try {
        document.body.style.marginRight = (window.innerWidth - (window.jQuery ? jQuery(window).width() : document.documentElement.clientWidth)) + 'px';
      } catch(_) {}
    }

    close() {
      const err = document.querySelectorAll('.cart-item__error-text');
      err && err.forEach(e => e.innerHTML = '');
      this.notification.classList.remove('active');
      setTimeout(function(){
        document.body.classList.remove('minicart-active');
        document.body.style.marginRight = '0px';
      },300);
      clearTimeout(this.closeTimeoutID);
    }

    isOpen() {
      return document.body.classList.contains('minicart-active');
    }

    renderContents(parsedState, options = {}) {
      var _this = this;
      const parsedStateSections = parsedState.sections;
      if (parsedStateSections != undefined) {
        _this.updateContent(parsedStateSections);
      }
      var autoClose = true;
      const doCount = () => {
        return fetch(window.Shopify.routes.root + 'cart.js')
          .then((response) => response.json())
          .then((parsedState) => {
            autoClose = parsedState.hasOwnProperty('items') ? false : true;
            window.cartCount && window.cartCount(parsedState);
            if (options.skipOpen) {
              window.initFreeshippingGoal && window.initFreeshippingGoal(parsedState);
              window.renderCrosssellProducts && parsedStateSections && window.renderCrosssellProducts(parsedStateSections);
            }
            return parsedState;
          })
          .catch((e) => console.error(e));
      };

      if (options.skipOpen) {
        return doCount();
      }

      doCount();
      this.open(autoClose);
    }

    updateContent(parsedStateSections) {
      var _this = this;
      this.getSectionsToRender().forEach((section => {
        const parsedStateHtml = new DOMParser().parseFromString(parsedStateSections[section.id], 'text/html');
        if (
          section.id == 'cart-notification-content' &&
          section.hasOwnProperty('elements') &&
          document.getElementById(section.id).querySelector('[data-mini-cart-wrapper]') &&
          parsedStateHtml.querySelector('[data-mini-cart-wrapper]')
        ) {
          section['elements'].forEach(function(elem) {
            const content = _this.getSectionInnerHTML(parsedStateSections[section.id], elem);
            const container = document.getElementById(section.id).querySelector(elem);
            if (!container) return;
            if (content != '') {
              container.classList.remove('d-none');
              container.innerHTML = content;
            } else {
              container.classList.add('d-none');
            }
          });
        } else {
          const el = document.getElementById(section.id);
          if (el) el.innerHTML = this.getSectionInnerHTML(parsedStateSections[section.id]);
        }
      }));

      this.ItemCount();
      if (document.body.querySelector('.estimate-shipping')) {
        this.shippingCalcultor();
      }
      this.cartAddonIcon();
      this.CartActionBtn();
      this.CartcancleBtn();
      this.checkedgiftWrap();

      // Bridge / bindings para o calculador de frete no mini-cart
      this.initMiniCartShippingBridge();
    }

    ItemCount() {
      fetch(window.Shopify.routes.root + 'cart.js')
        .then((response) => response.json())
        .then((parsedState) => {
          const el = document.querySelector(".cart-count");
          if (!el) return;
          const cartItem = parsedState.item_count;
          const ProductText = el.getAttribute("data-product");
          const ProductsText = el.getAttribute("data-products");
          el.innerHTML = cartItem > 1 ? (cartItem + " " + ProductsText) : (cartItem + " " + ProductText);
        })
        .catch((e) => console.error(e));
    }

    checkedgiftWrap(){
      const GiftChecked = localStorage.getItem("gift_wrap"),
            giftIcon = document.querySelector('[data-action="gift"]'),
            overlayElement = document.querySelector('.mini-cart-overlay');
      if (GiftChecked == 'true' && giftIcon) {
        giftIcon.remove();
        overlayElement && overlayElement.classList.remove("open");
      }
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-notification-content',
          elements: ['[data-mini-cart-wrapper]', '[data-cart-bottom]']
        },
        {
          id: 'cart-notification-crosssell-products'
        }
      ];
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
      return parsedHtml.querySelector(selector) ? parsedHtml.querySelector(selector).innerHTML : ''; 
    }

    setActiveElement(element) {
      this.activeElement = element;
    }

    cartAddonIcon() {
      const addonBtn = document.querySelectorAll('.addon-icon a'),
            overlayElement = document.querySelector('.mini-cart-overlay');
      addonBtn.forEach((e => {
        e.addEventListener("click", (ev => {
          ev.preventDefault();
          overlayElement && overlayElement.classList.add("open");
          const selectedElement = ev.target,
                buttonElement = selectedElement.closest('.addon-btn'),
                contentElement = document.querySelectorAll('.addon-content'),
                action = buttonElement.getAttribute("data-action");
          contentElement.forEach((Element) => {
            const addontContent = Element.getAttribute("data-content");
            if (addontContent == action ) Element.classList.add("open"); else Element.classList.remove("open");
          });
        }), !1)
      }));
    }

    CartcancleBtn() {
      const addonBtn = document.querySelectorAll('.addon-action .btn-cancel'),
            overlayElement = document.querySelector('.mini-cart-overlay');
      addonBtn.forEach((e => {
        e.addEventListener("click", (ev => {
          ev.preventDefault();
          overlayElement && overlayElement.classList.remove("open");
          const selectedElement = ev.target,
                contentElement = document.querySelectorAll('.addon-content'),
                action = selectedElement.getAttribute("data-cancel");
          contentElement.forEach((Element) => {
            const addontContent = Element.getAttribute("data-content");
            if (addontContent == action ) Element.classList.remove("open");
          });
        }), !1)
      }));
    }

    CartActionBtn() {
      const actionBtn = document.querySelectorAll('.btn-save'),
            overlayElement = document.querySelector('.mini-cart-overlay');
      actionBtn.forEach((e => {
        e.addEventListener("click", (ev => {
          ev.preventDefault();
          const selectedElement = ev.target,
                contentElement = document.querySelectorAll('.addon-content'),
                action = selectedElement.getAttribute("data-action");

          if (action == 'shipping') {
            var e = {};
            (e.zip = document.querySelector("#address_zip")?.value || ""),
            (e.country = document.querySelector("#address_country")?.value || ""),
            (e.province = document.querySelector("#address_province")?.value || ""),
            this.getCartShippingRatesForDestination(e);
          }
          else if(action == 'note') {
            overlayElement && overlayElement.classList.remove("open");
            contentElement.forEach((Element) => {
              const addontContent = Element.getAttribute("data-content");
              if (addontContent == action ) Element.classList.remove("open");
            });
            try {
              const body = JSON.stringify({
                note: document.querySelector("#Cart-note")?.value || '',
              });
              if (typeof routes !== 'undefined' && typeof fetchConfig === 'function') {
                fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body });
              }
            } catch(e) {
              console.warn('cart note update skipped:', e);
            }
          }
          else {
            try {
              Shopify.GiftWrap.update({
                'giftId': selectedElement.dataset.giftId,
                'giftQty': selectedElement.dataset.giftQty,
                'giftWrap': '',
                'giftMsg': ''
              });
              localStorage.setItem("gift_wrap", true);
              localStorage.setItem("gift_id", selectedElement.dataset.giftId);
            } catch(e) {
              console.warn('GiftWrap not available:', e);
            }
          }
        }), !1)
      }));
    }

    // ===== Mini-cart legacy (campos address_*) =====
    getCartShippingRatesForDestination(event) {
      fetch(`${window.Shopify.routes.root}cart/shipping_rates.json?shipping_address%5Bzip%5D=${event.zip}&shipping_address%5Bcountry%5D=${event.country}&shipping_address%5Bprovince%5D=${event.province}`)
        .then((response) => response.text())
        .then((state) => {
          const message = document.querySelector(".wrapper-response");
          document.querySelectorAll(".wrapper-response p").forEach(n => n.remove());
          const parsedState = JSON.parse(state);

          if (parsedState && parsedState.shipping_rates) {
            if (parsedState.shipping_rates.length > 0) {
              message.classList.remove("error","warning");
              message.classList.add("success");
              const p = document.createElement("p");
              p.innerHTML = `<strong>${'We found ' + parsedState.shipping_rates.length + ' shipping rate(s) for your Postal/ZIP code:'}<strong>`;
              message.appendChild(p);

              parsedState.shipping_rates.forEach((rate) => {
                const priceText = Number(rate.price) === 0
                  ? 'GRÁTIS'
                  : (Shopify && Shopify.formatMoney ? Shopify.formatMoney(rate.price, window.cartStrings?.money_format) : (new Intl.NumberFormat('pt-BR', {style:'currency',currency:'BRL'}).format(Number(rate.price)/100)));

                const rateNode = document.createElement("div");
                rateNode.className = "shipping-option";
                rateNode.innerHTML = `
                  <div class="shipping-header">
                    <div class="shipping-name">${rate.name}</div>
                    <div class="shipping-price">${priceText}</div>
                  </div>
                `;
                message.appendChild(rateNode);
              });
            } else {
              const p = document.createElement("p");
              p.innerText = 'No shipping options were found';
              message.appendChild(p);
            }
          } else {
            message.classList.remove("success","warning");
            message.classList.add("error");
            if (parsedState && typeof parsedState === 'object') {
              Object.entries(parsedState).forEach((error) => {
                const message_error = `${Array.isArray(error[1]) ? error[1][0] : error[1]}`;
                const p = document.createElement("p");
                p.innerText = message_error;
                message.appendChild(p);
              });
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }

    shippingCalcultor(){
      Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
        this.countryEl = document.querySelector('#address_country');
        this.provinceEl = document.querySelector('#address_province');
        this.provinceContainer = document.getElementById(options["hideElement"] || province_domid);
        this.initCountry();
        this.initProvince();
        this.onchange();
      };
      Shopify.CountryProvinceSelector.prototype = {
        onchange:function(){
          var changeElement = document.querySelector("#address_country");
          changeElement && changeElement.addEventListener("change", (e => {
            var opt = this.countryEl.options[this.countryEl.selectedIndex];
            var raw = opt.getAttribute("data-provinces");
            var provinces = JSON.parse(raw || '[]');
            var selector = document.querySelector('#address_province');
            while (selector.firstChild) { selector.removeChild(selector.firstChild); }
            if (provinces && provinces.length == 0) {
              this.provinceContainer.style.display = "none";
            } else {
              for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement("option");
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
              }
              this.provinceContainer.style.display = "";
            }
          }), !1)
        },
        initCountry: function () {
          var value = this.countryEl.getAttribute("data-default");
          Shopify.setSelectorByValue(this.countryEl, value);
          this.countryHandler();
        },
        initProvince: function () {
          var value = this.provinceEl.getAttribute("data-default");
          if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
          }
        },
        countryHandler: function () {
          var opt = this.countryEl.options[this.countryEl.selectedIndex];
          var raw = opt.getAttribute("data-provinces");
          var provinces = JSON.parse(raw || '[]');
          var selector = document.querySelector('#address_province');
          while (selector.firstChild) { selector.removeChild(selector.firstChild); }
          if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = "none";
          } else {
            for (var i = 0; i < provinces.length; i++) {
              var opt = document.createElement("option");
              opt.value = provinces[i][0];
              opt.innerHTML = provinces[i][1];
              this.provinceEl.appendChild(opt);
            }
            this.provinceContainer.style.display = "";
          }
        },
      };
      Shopify.setSelectorByValue = function (selector, value) {
        for (var i = 0, count = selector.options.length; i < count; i++) {
          var option = selector.options[i];
          if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
          }
        }
      };
      new Shopify.CountryProvinceSelector("address_country", "address_province", { hideElement: "address_province_container" });
    // 🔢 Forçar teclado numérico (calculadora legacy)
      const zipLegacy = document.querySelector('#address_zip');
      if (zipLegacy) {
        zipLegacy.setAttribute('inputmode', 'numeric');
        zipLegacy.setAttribute('pattern', '[0-9]*');
        zipLegacy.setAttribute('autocomplete', 'postal-code');
        zipLegacy.setAttribute('enterkeyhint', 'go');
        // opcional para iOS:
        // if (/iP(hone|od|ad)/.test(navigator.platform)) zipLegacy.type = 'tel';
      }

    
    }

    // ==== BRIDGE: shipping-calculator no mini-cart (markup com #cart-frete-dinamico-*) ====
    initMiniCartShippingBridge() {
      // Define a função global se não existir (para o inline onclick)
      if (typeof window.generateCartShippingRates !== 'function') {
        window.generateCartShippingRates = async (btn) => {
          const wrapper = btn?.closest('.cart-frete-dinamico') || document;
          const zipInput = wrapper.querySelector('#cart-frete-dinamico-cep');
          if (!zipInput) return;

          const zip = (zipInput.value || '').replace(/\D/g, '');
          const cepRegex = /^[0-9]{8}$/;

          const danger  = wrapper.querySelector('#cart-frete-danger');
          const aviso   = wrapper.querySelector('#cart-frete-aviso');
          const sucesso = wrapper.querySelector('#cart-frete-sucesso');

          // limpar
          [danger,aviso,sucesso].forEach(el => { if (el) { el.innerHTML=''; el.setAttribute('hidden','hidden'); } });

          if (!cepRegex.test(zip)) {
            if (aviso) {
              aviso.innerHTML = `<p class="mb-0">Formato de CEP Inválido.</p>`;
              aviso.removeAttribute('hidden');
            }
            return;
          }

          // spinner robusto
          const originalLabel = btn.dataset.text || btn.textContent || 'Calcular';
          btn.disabled = true;
          btn.innerHTML = `<span class="spinner" style="display:inline-block;width:16px;height:16px;border:2px solid #ccc;border-top-color:#333;border-radius:50%;animation:spin .6s linear infinite"></span>`;

          try {
            // 1) CEP -> estado (BrasilAPI)
            const respCep = await fetch(`https://brasilapi.com.br/api/cep/v1/${zip}`);
            if (!respCep.ok) throw new Error('CEP não encontrado');
            const dataCEP = await respCep.json();
            const province = dataCEP.state || 'BR';

            // 2) Calcula e renderiza
            await this.calculateMiniCartRates(zip, 'BR', province, wrapper);
          } catch (e) {
            if (aviso) {
              aviso.innerHTML = `<p class="mb-0">Erro ao calcular frete. ${e?.message || ''}</p>`;
              aviso.removeAttribute('hidden');
            }
          } finally {
            // SEMPRE restaurar o botão
            btn.innerHTML = originalLabel;
            btn.disabled = false;
          }
        };
      }

      // Máscara do CEP
      document.querySelectorAll('#cart-frete-dinamico-cep').forEach(input => {
        if (input.dataset._jvMask === '1') return;
        input.dataset._jvMask = '1';

        // 🔢 Forçar teclado numérico (mini-cart)
        input.setAttribute('inputmode', 'numeric');
        input.setAttribute('pattern', '[0-9]*');
        input.setAttribute('autocomplete', 'postal-code');
        input.setAttribute('enterkeyhint', 'go');
        // opcional para iOS:
        // if (/iP(hone|od|ad)/.test(navigator.platform)) input.type = 'tel';

        input.addEventListener('input', function (e) {
          const v = e.target.value.replace(/\D/g, '');
          e.target.value = v.length > 5 ? `${v.slice(0,5)}-${v.slice(5,8)}` : v;
        });
      });


      // Bind de clique: só adiciona se NÃO houver onclick inline para evitar duplo disparo
      document.querySelectorAll('#cart-frete-dinamico-btn').forEach(btn => {
        if (btn.dataset._jvBound === '1') return;
        if (btn.getAttribute('onclick')) return; // evita duplicidade
        btn.dataset._jvBound = '1';
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          window.generateCartShippingRates(btn);
        });
      });

      // --- NOVO: Enter também dispara o cálculo ---
      document.querySelectorAll('#cart-frete-dinamico-cep').forEach(input => {
        if (input.dataset._jvEnter === '1') return;
        input.dataset._jvEnter = '1';
        input.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            const wrapper = input.closest('.cart-frete-dinamico') || document;
            const btn = wrapper.querySelector('#cart-frete-dinamico-btn');
            if (!btn || btn.disabled) return;
            window.generateCartShippingRates(btn);
          }
        });
      });
      // (opcional) Enter no botão também
      document.querySelectorAll('#cart-frete-dinamico-btn').forEach(btn => {
        if (btn.dataset._jvEnter === '1') return;
        btn.dataset._jvEnter = '1';
        btn.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            if (!btn.disabled) window.generateCartShippingRates(btn);
          }
        });
      });

      // Observa re-renders do mini-cart e rebinda automaticamente
      if (!this._shippingMo) {
        this._shippingMo = new MutationObserver(() => {
          this.initMiniCartShippingBridge();
        });
        const target = document.getElementById('cart-notification-content') || document.body;
        this._shippingMo.observe(target, { childList: true, subtree: true });
      }
    }

    async calculateMiniCartRates(zip, country, province, wrapper) {
      const aviso   = wrapper.querySelector('#cart-frete-aviso');
      const sucesso = wrapper.querySelector('#cart-frete-sucesso');

      // Primeira tentativa
      const url = `/cart/shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`;
      try {
        const r = await fetch(url, { method:'GET', headers: { 'X-Requested-With':'XMLHttpRequest','Content-Type':'application/json' }});
        if (!r.ok) throw new Error('fallback');
        const text = await r.text();
        let json;
        try { json = JSON.parse(text); } catch(_) { throw new Error('Resposta inválida'); }
        return this.renderMiniCartRates(json, wrapper);
      } catch(_) {
        // Alternativo: prepare + polling
        try {
          await this.tryAlternativeMiniCart(zip, country, province, wrapper);
        } catch(e) {
          if (aviso) {
            aviso.innerHTML = `<p class="mb-0">Não foi possível obter as opções de frete no momento.</p>`;
            aviso.removeAttribute('hidden');
          }
        }
      }
    }

    async tryAlternativeMiniCart(zip, country, province, wrapper) {
      const form = new URLSearchParams();
      form.append('shipping_address[zip]', zip);
      form.append('shipping_address[country]', country);
      form.append('shipping_address[province]', province);

      const prep = await fetch('/cart/prepare_shipping_rates', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
        body: form
      });
      if (!prep.ok) throw new Error('Prepare failed');

      for (let i = 0; i < 10; i++) {
        await new Promise(r => setTimeout(r, 1000));
        const r = await fetch('/cart/async_shipping_rates', { headers: { 'X-Requested-With':'XMLHttpRequest' } });
        if (r.status === 200) {
          const json = await r.json();
          if (json && json.shipping_rates && json.shipping_rates.length) {
            return this.renderMiniCartRates(json, wrapper);
          }
        }
      }
      throw new Error('Timeout polling');
    }

    renderMiniCartRates(json, wrapper) {
      const sucesso = wrapper.querySelector('#cart-frete-sucesso');
      const aviso   = wrapper.querySelector('#cart-frete-aviso');

      if (!json.shipping_rates || !json.shipping_rates.length) {
        if (aviso) {
          aviso.innerHTML = `<p class="mb-0">Não encontramos opções de frete para o CEP informado.</p>`;
          aviso.removeAttribute('hidden');
        }
        return;
      }

      const fmt = (price) => {
        if (Number(price) === 0) return '<p class="frete-teste-gratis" style="margin:0;">GRÁTIS</p>';
        const num = Number(String(price).replace(',', '.'));
        if (!isFinite(num)) return price;
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(num);
      };

      let html = '';
      json.shipping_rates.forEach(rate => {
        const delivery = this.computeDeliveryTime(rate);
        html += `
          <div class="shipping-option">
            <div class="shipping-header">
              <div class="shipping-name">${rate.name}</div>
              <div class="shipping-price">${fmt(rate.price)}</div>
            </div>
            ${delivery ? `<div class="shipping-delivery-time">${delivery}</div>` : ``}
          </div>
        `;
      });

      if (sucesso) {
        sucesso.innerHTML = html;
        sucesso.removeAttribute('hidden');
      }
    }

    computeDeliveryTime(rate) {
      const extractFromText = (name) => {
        if (!name) return null;
        const tests = [
          { regex:/(\d+)\s*(?:a|à|-)\s*(\d+)\s*dias?\s*(?:úteis?|uteis?)/i, fmt:(m)=>`${m[1]}-${m[2]} dias úteis` },
          { regex:/(\d+)\s*dias?\s*(?:úteis?|uteis?)/i, fmt:(m)=> (parseInt(m[1],10)===1?'1 dia útil':`${m[1]} dias úteis`) },
          { regex:/(\d+)\s*(?:a|à|-)\s*(\d+)\s*dias?/i, fmt:(m)=>`${m[1]}-${m[2]} dias` },
          { regex:/(\d+)\s*dias?/i, fmt:(m)=> (parseInt(m[1],10)===1?'1 dia':`${m[1]} dias`) }
        ];
        for (const t of tests) {
          const m = name.match(t.regex);
          if (m) return t.fmt(m);
        }
        return null;
      };

      const deliveryRange = rate.delivery_range ? String(rate.delivery_range).trim() : '';
      const deliveryDate  = rate.delivery_date ? String(rate.delivery_date).trim() : '';

      if (deliveryRange && deliveryRange !== 'null' && deliveryRange !== 'undefined') {
        if (deliveryRange.includes(',') && deliveryRange.includes('-')) {
          const [startDate, endDate] = deliveryRange.split(',').map(s=>s.trim());
          try {
            const start = new Date(startDate);
            const end   = new Date(endDate);
            const today = new Date();
            const diffStart = Math.ceil((start - today) / 86400000);
            if (diffStart <= 0) return 'Entrega hoje';
            if (diffStart === 1) return '1 dia útil';
            if (startDate === endDate) return `${diffStart} dias úteis`;
            const diffEnd = Math.ceil((end - today) / 86400000);
            return `${diffStart} a ${diffEnd} dias úteis`;
          } catch { return deliveryRange; }
        }
        return deliveryRange;
      }
      if (deliveryDate && deliveryDate !== 'null' && deliveryDate !== 'undefined') return deliveryDate;
      if (rate.delivery_estimate_business_days && rate.delivery_estimate_business_days !== 'undefined') {
        const d = parseInt(rate.delivery_estimate_business_days,10);
        if (d > 0) return d === 1 ? '1 dia útil' : `${d} dias úteis`;
      }
      if (rate.delivery_estimate_transit_time_business_days && rate.delivery_estimate_transit_time_business_days !== 'undefined') {
        const d = parseInt(rate.delivery_estimate_transit_time_business_days,10);
        if (d > 0) return d === 1 ? '1 dia útil' : `${d} dias úteis`;
      }
      if (rate.delivery_days && Array.isArray(rate.delivery_days) && rate.delivery_days.length > 0) {
        const last = rate.delivery_days[rate.delivery_days.length - 1];
        return last === 1 ? '1 dia útil' : `${last} dias úteis`;
      }
      if (rate.description && rate.description.trim() !== '') {
        return extractFromText(rate.description.trim()) || rate.description.trim();
      }
      return extractFromText(rate.name) || '';
    }
  }

  customElements.define('cart-notification', CartNotification);

  function getCartNotificationInstance() {
    return document.querySelector('cart-notification');
  }

  function bindMiniCartOpenHandlers() {
    if (window.__MG_MINICART_OPEN_BOUND__) return;
    window.__MG_MINICART_OPEN_BOUND__ = true;

    document.addEventListener('click', function(event) {
      const trigger = event.target.closest('[cart-icon-bubble], .sticky-menu-item.sticky-cart');
      if (!trigger) return;

      const cartNotification = getCartNotificationInstance();
      if (!cartNotification || typeof cartNotification.open !== 'function') return;

      event.preventDefault();
      cartNotification.open();
    }, true);
  }

  function bindMiniCartCloseHandlers() {
    if (window.__MG_MINICART_CLOSE_BOUND__) return;
    window.__MG_MINICART_CLOSE_BOUND__ = true;

    const isCartOpenTrigger = (target) => {
      return !!(target && target.closest('[cart-icon-bubble], .sticky-menu-item.sticky-cart'));
    };

    document.addEventListener('click', function(event) {
      const cartNotification = getCartNotificationInstance();
      const panel = document.getElementById('cart-notification');
      if (!cartNotification || !panel || !document.body.classList.contains('minicart-active')) return;

      if (isCartOpenTrigger(event.target)) return;

      const closeBtn = event.target.closest('[data-cart-notification-close]');
      if (closeBtn && panel.contains(closeBtn)) {
        event.preventDefault();
        event.stopPropagation();
        cartNotification.close();
        return;
      }

      if (!panel.contains(event.target)) {
        cartNotification.close();
      }
    }, true);

    document.addEventListener('keydown', function(event) {
      if (event.key !== 'Escape') return;
      const cartNotification = getCartNotificationInstance();
      if (!cartNotification || !document.body.classList.contains('minicart-active')) return;
      cartNotification.close();
    });
  }

  bindMiniCartOpenHandlers();
  bindMiniCartCloseHandlers();

  window.updateCartNotification = function updateCartNotification(elem, id, quantity, resetQty, preQty, line) {
    if (window.__cartNotificationUpdating) return;

    const cartNotification = document.querySelector('cart-notification');
    const cartEl = document.getElementById('cart-notification');
    if (!cartNotification || !cartEl) return;

    window.__cartNotificationUpdating = true;
    cartEl.classList.add('loading');

    const requestedQty = Number(quantity);
    const payload = {
      quantity,
      sections: cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    };
    if (id) payload.id = id;
    else if (line) payload.line = Number(line);

    const finish = () => {
      cartEl.classList.remove('loading');
      window.__cartNotificationUpdating = false;
    };

    const refreshMiniCartSections = () => {
      return fetch(`${window.Shopify.routes.root}?sections=cart-notification-content,cart-notification-crosssell-products`)
        .then((response) => response.json())
        .then((sections) => {
          cartNotification.updateContent(sections);
          window.renderCrosssellProducts && window.renderCrosssellProducts(sections);
          return fetch(window.Shopify.routes.root + 'cart.js').then((r) => r.json());
        })
        .then((cartState) => {
          window.initFreeshippingGoal && window.initFreeshippingGoal(cartState);
          window.cartCount && window.cartCount(cartState);
        })
        .catch((e) => console.error(e));
    };

    const applySuccess = (response, stockLimitMessage) => {
      const renderPromise = response.sections
        ? Promise.resolve(cartNotification.renderContents(response, { skipOpen: true }))
        : refreshMiniCartSections();

      return renderPromise.then(() => {
        if (stockLimitMessage && id) {
          const refreshedInput = document.querySelector(`.cart-notification-products .quantity-input[data-id="${id}"]`);
          const refreshedError = refreshedInput ? refreshedInput.closest('.cart-product-info')?.querySelector('.cart-item__error-text') : null;
          if (refreshedError) refreshedError.textContent = stockLimitMessage;
        }
      });
    };

    fetch(`${window.Shopify.routes.root}cart/change.js`, {
      ...(typeof fetchConfig === 'function' ? fetchConfig() : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }),
      body: JSON.stringify(payload)
    })
    .then((response) => response.json())
    .then((response) => {
      if (response.status == 422) {
        if (elem && elem.jquery) {
          const erroritem = elem.closest('.cart-product-info').find('.cart-item__error-text');
          $(erroritem).html(response.message);
          if (resetQty === true) elem.val(preQty);
        }
        finish();
        return;
      }

      let stockLimitMessage = '';
      if (!Number.isNaN(requestedQty) && id) {
        const updatedItem = (response.items || []).find((item) => item.key === id);
        if (updatedItem && Number(updatedItem.quantity) < requestedQty) {
          const allowedQty = Number(updatedItem.quantity) || 0;
          const itemLabel = allowedQty === 1 ? 'item' : 'itens';
          stockLimitMessage = `Somente ${allowedQty} ${itemLabel} foram adicionados ao seu carrinho devido à disponibilidade.`;
        }
      }

      return applySuccess(response, stockLimitMessage).finally(finish);
    })
    .catch((e) => {
      if (resetQty === true && elem && elem.jquery) {
        elem.val(elem.val() - 1);
      }
      console.error(e);
      finish();
    });
  };

  if (!window.__MG_MINICART_ACTIONS_BOUND__) {
    window.__MG_MINICART_ACTIONS_BOUND__ = true;

    document.addEventListener('click', function(event) {
      const removeBtn = event.target.closest('[data-cart-notification-item-remove]');
      if (!removeBtn || !document.querySelector('cart-notification')) return;

      event.preventDefault();
      event.stopPropagation();

      const itemId = removeBtn.getAttribute('data-item-id');
      const giftId = localStorage.getItem('gift_id');
      if (giftId == itemId) {
        localStorage.removeItem('gift_wrap');
      }

      window.updateCartNotification(
        window.jQuery ? jQuery(removeBtn) : removeBtn,
        removeBtn.getAttribute('data-id'),
        0,
        false,
        null,
        removeBtn.getAttribute('data-line')
      );
    }, true);

    document.addEventListener('change', function(event) {
      const input = event.target.closest('.cart-notification-products .quantity-input');
      if (!input || !document.querySelector('cart-notification')) return;

      event.preventDefault();
      window.updateCartNotification(
        window.jQuery ? jQuery(input) : input,
        input.getAttribute('data-id'),
        input.value,
        true,
        input.getAttribute('data-qty')
      );
    }, true);
  }

  // spinner keyframes (para o bridge)
  const style = document.createElement('style');
  style.textContent = '@keyframes spin{to{transform:rotate(360deg)}}';
  document.head.appendChild(style);
},200);
